import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';
import { black } from 'Styles/colors';

export const Title = styled.p`
  ${fontTitle(16)};
  color: ${black};
  padding: 6px 0 6px 0;
  margin: 0;
`;

export const List = styled.ul`
  ${fontBody(14)}
  list-style-type: none;
  padding-left: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  color: ${black};
  padding-top: 8px;
  padding-bottom: 6px;
  a:visited {
    color: ${black};
  }
`;

export const Link = styled.a`
  text-decoration: none;
  color: ${black};

  a:visited {
    color: ${black};
  }

  &:hover {
    text-decoration: underline;
  }
`;
